import React, {Component} from 'react';
import {connect} from 'react-redux'

import {Power2, Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'

import CartView from '../containers/cart/CartView'
import PromotionCodeBox from '../containers/cart/PromotionCodeBox'
import Column from '../components/Column'


class StickyColumn extends Component {

    static propTypes = {}

    static defaultProps = {}

    static resizeTimeout = 0

    constructor(props) {
        super(props)
        this.state = {
            isSticky: false,
            scrollTimeout: false,
            offsetTop: 0,
            orderImageLoaded: false,
            orderBoxBottomBeforeHide: 0,
            orderBoxHeightBeforeHide: 0,
            hideSupportBox: false
        }
    }

    getOffsetTop = (elem) => {
        let offsetTop = 0;
        do {
            if (!isNaN(elem.offsetTop)) {
                offsetTop += elem.offsetTop
            }
            elem = elem.offsetParent
        } while (elem)
        return offsetTop
    }

    isWindowHighEnough = () => {

        const dom = ReactDOM.findDOMNode(this)

        if (dom.offsetHeight + 20 < window.innerHeight) {

            return true

        } else {

            return false

        }

    }

    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll)

        const dom = ReactDOM.findDOMNode(this)

        this.setState({
            offsetTop: this.getOffsetTop(dom)
        })

        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.from(dom, 0.8, {delay: 0.25, ease: Power3.easeOut, opacity: 0, y: -20})

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }


    shouldComponentUpdate(nextProps, nextState) {

        if (this.state.isSticky !== nextState.isSticky) {
            return true
        }

        if (this.state.orderImageLoaded !== nextState.orderImageLoaded) {
            return true
        }

        if (this.props.supportBoxVisible !== nextProps.supportBoxVisible) {
            return true
        }

        return false

    }

    handleScroll = (e) => {

        const dom = ReactDOM.findDOMNode(this)
        const body = document.body
        const html = document.documentElement
        const documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const footerHeight = document.getElementsByClassName('footer-wrapper')[0].offsetHeight
        const stepDisplayHeight = document.getElementsByClassName('step-display')[0].offsetHeight

        if (window.scrollY > this.state.offsetTop && this.isWindowHighEnough() && dom.offsetHeight < stepDisplayHeight) {

            const targetOffsetY = Math.min(documentHeight - this.state.offsetTop - 60 - footerHeight - dom.offsetHeight, 20 + window.scrollY - this.state.offsetTop)

            TweenLite.killTweensOf(dom, {top: true})
            TweenLite.to(dom, 0.3, {ease: Power2.easeOut, top: targetOffsetY})

        } else {

            TweenLite.killTweensOf(dom, {top: true})
            TweenLite.to(dom, 0.3, {
                ease: Power2.easeOut, top: 0, onComplete: () => {
                    this.setState({isSticky: false})
                }
            })

        }

    }

    render() {

        return (
            <Column ref="outside" {...this.props} isSticky={this.state.isSticky}>
                <CartView ref="cartview"/>
                <PromotionCodeBox ref="promotion"/>
            </Column>
        )

    }

}


const mapStateToProps = (state, ownProps) => {

    return {
        supportBoxVisible: state.ui.supportBoxVisible
    }

}

const mapDispatchToProps = (dispatch) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps, null)(StickyColumn)



/** WEBPACK FOOTER **
 ** ./src/containers/StickyColumn.js
 **/